/** 子应用「设置」大区下的二级导航（对齐账户管理：设置是大区，成员等是子项） */

export type ProductSettingsNavItem = {
  key: string;
  title: string;
};

/** 按产品键配置；无配置则「设置」仍为单页占位 */
const SETTINGS_CHILDREN: Record<string, ProductSettingsNavItem[]> = {
  journey: [
    { key: "journeys", title: "旅程配置" },
    { key: "members", title: "成员权限" },
  ],
};

export function productSettingsChildren(appKey: string | null | undefined): ProductSettingsNavItem[] {
  if (!appKey) return [];
  return SETTINGS_CHILDREN[appKey] ?? [];
}

/** 设置默认落地子路径（首个子项） */
export function defaultSettingsSubsection(appKey: string | null | undefined): string | null {
  return productSettingsChildren(appKey)[0]?.key ?? null;
}

/**
 * 侧栏设置大区标题：Journey 固定「旅程设置」，AISO「AISO 设置」，其余「{产品名}设置」。
 */
export function productSettingsSectionTitle(
  appKey: string | null | undefined,
  productName: string | null | undefined,
): string {
  if (appKey === "journey") return "旅程设置";
  if (appKey === "aiso") return "AISO 设置";
  const name = (productName ?? "").trim();
  return name ? `${name}设置` : "设置";
}
